<template>
  <b-container class="pt-5">
    <b-row align-h="center" align-v="center" class="bg-light rounded">
      <b-col class="p-4">
        <h2>Zarządzanie wnioskami</h2>
        <hr />
        <b>Imię:</b> {{ proxy_user.given_name }} <br />
        <b>Nazwisko:</b> {{ proxy_user.family_name }} <br />
        <b>Nazwa kancelarii:</b> {{ proxy_user.office_name }} <br />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from "vue";

export default {
  name: "ProxyManage",
  data() {
    return {
      proxy_user: {
        given_name: null,
        family_name: null,
        office_name: null
      }
    };
  },
  mounted() {
    this.$nextTick(function() {
      var $this = this;
      Vue.CognitoAuth.get_current_user_data().then(function(user_data) {
        if (user_data) {
          $this.proxy_user = user_data;
        }
      });
    });
  }
};
</script>

<style scoped></style>
